import DownloadIcon from "@mui/icons-material/Download";
import TableViewIcon from "@mui/icons-material/TableView";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import RefreshIcon from "@mui/icons-material/Refresh";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import RemoveIcon from "@mui/icons-material/Remove";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  IconButton,
  InputAdornment,
  ListItemIcon,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import SaveIcon from "@mui/icons-material/Save";
import Booking from "../api/booking";
import Machine from "../api/machine";
import LokaActivityIndicator from "../components/LokaActivityIndicator";
import ActivityIndicatorContext from "../Contexts/ActivityIndicatorContext";
import "../App.css";
// !------
import AddUpdateBooking from "../components/AddUpdateBooking";
import { AG_GRID_LOCALE_FR } from "@ag-grid-community/locale";
import { ColumnApiModule, ModuleRegistry } from "ag-grid-community";
import CheckingsHistory from "../components/CheckingsHistory";
import LokaSnackBar from "../components/LokaSnackBar";
// ! MODAL
import MachineDetails from "../components/MachineDetails";
import Selector from "../components/Selector";
import Colors from "../constants/colors.json";
import Language from "../constants/language_fr.json";
import SnackBarContext from "../Contexts/SnackBarContext";
import AddIcon from "@mui/icons-material/Add";
import AddUpdateMachine from "../components/AddUpdateMachine";
import { getDiscountList } from "../globals";
import { useSelector } from "react-redux";
const { GetApiCompanyDiscountGrid, GetAllContracts } = Booking || {};

const Catalog = () => {
  ModuleRegistry.registerModules([ColumnApiModule]);
  const { setActivityIndicator } = useContext(ActivityIndicatorContext);
  const { user, members, company } = useSelector(({ slice }) => slice.value);
  const {
    createBooking: createBookingRestriction,
    createEstimate: createEstimateRestriction,
    historyMachine: historyMachineRestriction,
    lockMachine: lockMachineRestriction,
    createMachine: createMachineRestriction,
  } = user?.configuration?.restrictions || {};

  const { setSnackBar } = useContext(SnackBarContext);

  const { GetGridCatalog } = Machine || {};

  const [columnAnchorEl, setColumnAnchorEl] = useState();
  const [columnDefs, setColumnDefs] = useState();
  const [initialBooking, setInitialBooking] = useState({
    bookingCosts: [],
    customer: {},
    rentalPeriod: [],
    rentalPrices: {},
    servicesSelected: {},
    equipmentsSelected: {},
    delivery: { key: "agencyPickUp" },
    state: "contract",
    machine: {},
  });
  const [isOpenAddUpBook, setIsOpenAddUpBook] = useState(false);
  const [isOpenAddMachine, setIsOpenAddMachine] = useState(false);
  const [isOpenChekingsHistory, setIsOpenChekingsHistory] = useState(false);
  const [isViewAdding, setIsViewAdding] = useState(false);
  const [localProps, setLocalProps] = useState({
    isGridReady: false,
    contractsByMachine: [],
    selectedMachine: {},
    uploading: false,
  });
  const [machineDetails, setMachineDetails] = useState({
    data: false,
    isVisible: false,
  });
  const [rowData, setRowData] = useState(null);
  const [search, setSearch] = useState();
  const [selectorList, setSelectorList] = useState([]);
  const [view, setView] = useState("Standard");

  const addViewInputRef = useRef(null);
  const gridRef = useRef(null);
  const fileInput = useRef(null);
  // Évite le double appel de constructor() au montage (React.StrictMode en dev)
  const isConstructed = useRef(false);

  const MainImage = ({ data }) => {
    const { mainPicture } = data || {};
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height={50}
      >
        {mainPicture ? (
          <img height="100%" src={mainPicture} alt="machine miniature" />
        ) : (
          <Typography
            fontSize={12}
            fontStyle="italic"
            color={Colors.greyShaded}
          >
            {mainPicture}
          </Typography>
        )}
      </Box>
    );
  };

  const constructor = async () => {
    setActivityIndicator({
      isOpen: true,
      message: Language.appBar.loading,
    });
    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));
    const { columnDefs: _columnDefs, viewDefs } = agGridConfig?.machine;
    setColumnDefs(_columnDefs);

    const [{ data }, _discountGrid] = await Promise.all([
      GetGridCatalog({
        token: user?.token,
        language: "fr",
      }),
      GetApiCompanyDiscountGrid({
        idCompany: user.idCompany,
        token: user.token,
      }),
    ]);
    const { defaultCategories } = company || {};
    const machineList = (data?.response || [])?.filter(({ category }) =>
      (defaultCategories || []).includes(category),
    );
    setRowData(machineList);

    setActivityIndicator({
      isOpen: false,
      message: null,
    });
    setMachineDetails({ data: false, isVisible: false });
    setLocalProps({
      ...localProps,
      isGridReady: true,
      discountGrid: _discountGrid,
      uploading: false,
      defaultViews: viewDefs?.length
        ? viewDefs
        : [
            "Standard",
            "Compteur",
            "Calendrier",
            "Prix",
            "Export",
            "Modèle d'import",
          ],
    });
  };
  useEffect(() => {
    if (isConstructed.current) return;
    isConstructed.current = true;
    constructor();
  }, []);

  const {
    contractsByMachine,
    defaultViews,
    discountGrid,
    isGridReady,
    selectedMachine,
    uploading,
  } = localProps || {};

  const initBooking = ({ jsonObject, state }) => {
    const {
      active,
      availableRangeDates,
      createdAt,
      delivery,
      group,
      id,
      idCompany,
      location,
      machine,
      machineFeatures,
      options,
      rentMode,
      benefits,
      equipments,
      pictures,
      updatedAt,
      user,
    } = jsonObject || {};

    const rentalPricesKey = rentMode?.dayPrice
      ? "dayPrice"
      : rentMode?.monthPrice
        ? "monthPrice"
        : rentMode?.surfacePrice
          ? "surfacePrice"
          : "unityPrice";

    const _discountList = getDiscountList({
      contractType: "standard",
      discountGrid,
      rentalPricesKey,
    });

    setInitialBooking({
      ...initialBooking,
      state,
      rentalPrices: {
        contractType: "standard",
        dayPrice: rentMode?.dayPrice || null,
        monthPrice: rentMode?.monthPrice || null,
        surfacePrice: rentMode?.surfacePrice || null,
        unityPrice: rentMode?.unityPrice || null,
        discountList: _discountList,
        key: rentalPricesKey,
        quantity: "0",
      },
      machine: {
        active,
        availableRangeDates,
        createdAt,
        delivery,
        group,
        id,
        idCompany,
        location,
        machine,
        machineFeatures,
        options,
        rentMode,
        benefits,
        equipments,
        pictures,
        updatedAt,
        user,
      },
      checker: user?.id,
      departureAgency: machine.agency,
      delivery: {
        ...initialBooking?.delivery,
        kmPrice: delivery?.distanceDeliveryPrice || "0",
      },
      subCompany: company?.subCompanies?.[0],
    });
    setIsOpenAddUpBook(true);
  };

  // const menu = [
  //   {
  //     isRestricted: createBookingRestriction,
  //     key: "createBooking",
  //     label: `Créer un contrat`,
  //     onClickAction: () =>
  //       initBooking({
  //         jsonObject: data?.jsonObject,
  //         state: "contract",
  //       }),
  //   },
  //   {
  //     isRestricted: createEstimateRestriction,
  //     key: "createEstimate",
  //     label: `Créer un devis`,
  //     onClickAction: () =>
  //       initBooking({
  //         jsonObject: data?.jsonObject,
  //         state: "estimate",
  //       }),
  //   },
  //   {
  //     isRestricted: lockMachineRestriction,
  //     key: "lock",
  //     label: isBookable ? Language.catalog.lock : Language.catalog.unlock,
  //     onClickAction: () => onHandleSwitchBookability(),
  //   },
  //   {
  //     isRestricted: historyMachineRestriction,
  //     key: "machineHistory",
  //     label: `Historique`,
  //     onClickAction: () => handleMachineHistory(data),
  //   },
  // ];

  const handleSearch = ({ target }) => {
    setSearch(target?.value);
  };

  const onHandleSwitchBookability = async ({ idMachine }) => {
    const { SwitchBookability } = Machine || {};
    const { status } = await SwitchBookability({
      idMachine,
      token: user.token,
    });
    if (status === 200) {
      constructor();
      setSnackBar({
        isOpen: true,
        message: Language.catalog.onSuccessfullUpdate,
        status: "success",
      });
    }
  };

  const getContextMenuItems = useCallback(({ node }) => [
    {
      action: () =>
        initBooking({
          jsonObject: node?.data?.jsonObject,
          state: "contract",
        }),
      disabled: createBookingRestriction,
      name: "Créer un contrat",
      tooltip: "Créer un nouveau contrat pour ce matériel",
    },
    {
      action: () =>
        initBooking({
          jsonObject: node?.data?.jsonObject,
          state: "estimate",
        }),
      disabled: createEstimateRestriction,
      name: "Créer un devis",
      tooltip: "Créer un nouveau devis pour ce matériel",
    },
    {
      action: () => onHandleSwitchBookability({ idMachine: node?.data?.id }),
      disabled: lockMachineRestriction,
      name: node?.data?.isBookable
        ? Language.catalog.lock
        : Language.catalog.unlock,
      tooltip: "Interdire la création de contrats / devis sur ce matériel",
    },
    {
      action: () => handleMachineHistory(node?.data),
      disabled: historyMachineRestriction,
      name: "Historique",
      tooltip:
        "Consulter les contrats et états des lieux associés à ce matériel",
    },
  ]);

  const handleCloseChekingsHistoryModal = () => {
    setLocalProps({ ...localProps, contractsByMachine: [] });
    setIsOpenChekingsHistory(false);
  };
  const handleStoreColumnDefs = () => {
    const { api } = gridRef.current || {};
    const _activeViewcolumnDefs = api?.getColumnDefs();

    setColumnDefs((_columnDefs) => ({
      ..._columnDefs,
      [view]: _activeViewcolumnDefs?.map(({ colId }) => colId),
    }));

    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));

    const _agGridConfig = {
      ...agGridConfig,
      machine: {
        ...agGridConfig?.machine,
        columnDefs: {
          ...agGridConfig?.machine?.columnDefs,
          [view]: _activeViewcolumnDefs?.map(({ colId }) => colId),
        },
      },
    };
    localStorage.setItem("agGridConfig", JSON.stringify(_agGridConfig));
  };

  const handleUpdateColumn = ({ key, isActive }) => {
    const _columnDefs = isActive
      ? {
          ...columnDefs,
          [view]: columnDefs?.[view].filter((item) => item !== key),
        }
      : { ...columnDefs, [view]: [key, ...columnDefs?.[view]] };
    setColumnDefs(_columnDefs);
    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));
    localStorage.setItem(
      "agGridConfig",
      JSON.stringify({
        ...agGridConfig,
        machine: { ...agGridConfig?.machine, columnDefs: _columnDefs },
      }),
    );
  };

  const InteractionRenderer = ({ data }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { id, isBookable } = data || {};

    return (
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-around"
        alignItems="center"
        height={50}
      >
        <IconButton
          aria-controls={
            Boolean(anchorEl) ? "machine-shortcut-actions" : undefined
          }
          aria-haspopup="true"
          aria-expanded={Boolean(anchorEl) ? "true" : undefined}
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
          }}
        >
          <MenuIcon
            style={{ color: isBookable ? Colors.green : Colors.greyShaded }}
          />
        </IconButton>
        <Menu
          id="machine-shortcut-actions"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          {[
            {
              isRestricted: createBookingRestriction,
              key: "createBooking",
              label: `Créer un contrat`,
              onClickAction: () =>
                initBooking({
                  jsonObject: data?.jsonObject,
                  state: "contract",
                }),
            },
            {
              isRestricted: createEstimateRestriction,
              key: "createEstimate",
              label: `Créer un devis`,
              onClickAction: () =>
                initBooking({
                  jsonObject: data?.jsonObject,
                  state: "estimate",
                }),
            },
            {
              isRestricted: lockMachineRestriction,
              key: "lock",
              label: isBookable
                ? Language.catalog.lock
                : Language.catalog.unlock,
              onClickAction: () =>
                onHandleSwitchBookability({
                  idMachine: data?.id,
                }),
            },
            {
              isRestricted: historyMachineRestriction,
              key: "machineHistory",
              label: `Historique`,
              onClickAction: () => handleMachineHistory(data),
            },
          ]?.map(({ isRestricted, key, label, onClickAction }) => (
            <MenuItem
              disabled={isRestricted || (!isBookable && key !== "lock")}
              key={key}
              onClick={() => onClickAction()}
            >
              <Typography
                style={{
                  color: Colors.grayText,
                }}
              >
                {label}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  };

  const gridApiHandler = (apiType) => {
    const { api } = gridRef.current || {};
    if (api) {
      switch (apiType) {
        case "exportDataAsExcel":
          api.exportDataAsExcel();
          break;
        default:
          console.log("This grid api type is not used in INSPEKT app.");
      }
    }
  };

  const handleAddView = () => {
    const addViewTextField = addViewInputRef?.current?.value;
    const viewName = addViewTextField?.replaceAll(" ", "_");
    const _viewDefs = [...localProps?.defaultViews, viewName];
    const _columnDefs = {
      ...columnDefs,
      [viewName]: columnDefs?.Standard,
    };
    setLocalProps((_localProps) => ({
      ..._localProps,
      defaultViews: _viewDefs,
    }));
    setColumnDefs(_columnDefs);
    const agGridConfig = JSON.parse(localStorage.getItem("agGridConfig"));
    localStorage.setItem(
      "agGridConfig",
      JSON.stringify({
        ...agGridConfig,
        booking: { columnDefs: _columnDefs, viewDefs: _viewDefs },
      }),
    );
    setIsViewAdding(false);
  };

  const handleMachineHistory = async ({ jsonObject }) => {
    const _contracts = await GetAllContracts({
      idMachine: jsonObject?.id,
      token: user.token,
    });
    setLocalProps({
      ...localProps,
      contractsByMachine: _contracts,
      selectedMachine: jsonObject,
    });

    setIsOpenChekingsHistory(true);
  };

  const onFirstDataRendered = (params) => {
    /**Display data on full width */
    params.api.sizeColumnsToFit();
  };

  const defaultColDef = {
    resizable: true,
    rowSelection: "multiple",
    filter: "agSetColumnFilter",
    suppressMenu: true,
  };

  const columnsConfiguration = {
    agency: {
      colId: "agency",
      field: "agency",
      headerName: "Agence stockage",
      type: "textColumn",
    },
    allRentalDays: {
      colId: "allRentalDays",
      headerName: "Jours loués",
      filter: "agNumberColumnFilter",
      valueGetter: ({ data: { allRentalDays } }) => {
        return allRentalDays ? Number(allRentalDays) : 0;
      },
    },
    availableEndDate: {
      colId: "availableEndDate",
      comparator: (a, b) => {
        const [aDay, aMonth, aYear] = a?.split("/") || [];
        const [bDay, bMonth, bYear] = b?.split("/") || [];
        const aDate = a ? new Date(aYear, aMonth, aDay) : null;
        const bDate = b ? new Date(bYear, bMonth, bDay) : null;
        return aDate === bDate ? 0 : aDate > bDate ? 1 : -1;
      },
      field: "availableEndDate",
      headerName: "Disponible jusqu'au",
      filter: "agDateColumnFilter",
      filterParams: {
        buttons: ["clear", "apply"],
      },
      valueGetter: ({ data }) => {
        const [date] = new Date(data?.availableEndDate)
          .toLocaleString("fr-FR", {
            timeZone: "UTC",
          })
          .split(" ");
        return data?.availableEndDate ? date : null;
      },
    },
    availableStartDate: {
      colId: "availableStartDate",
      comparator: (a, b) => {
        const [aDay, aMonth, aYear] = a?.split("/") || [];
        const [bDay, bMonth, bYear] = b?.split("/") || [];
        const aDate = a ? new Date(aYear, aMonth, aDay) : null;
        const bDate = b ? new Date(bYear, bMonth, bDay) : null;
        return aDate === bDate ? 0 : aDate > bDate ? 1 : -1;
      },
      field: "availableStartDate",
      headerName: "Disponible à partir du",
      filter: "agDateColumnFilter",
      filterParams: {
        buttons: ["clear", "apply"],
      },
      valueGetter: ({ data }) => {
        const [date] = new Date(data?.availableStartDate)
          .toLocaleString("fr-FR", {
            timeZone: "Europe/Paris",
          })
          .split(" ");
        return data?.availableStartDate ? date : null;
      },
    },
    brand: {
      colId: "brand",
      field: "brand",
      headerName: "Marque",
      type: "textColumn",
      valueGetter: ({ data }) => data.brand,
    },
    bondPrice: {
      colId: "bondPrice",
      headerName: "bondPrice",
      type: "textColumn",
      valueGetter: ({ data }) => data?.bondPrice,
    },
    category: {
      colId: "category",
      headerName: "category",
      type: "textColumn",
      valueGetter: ({ data }) => data.category,
    },
    dayPrice: {
      colId: "dayPrice",
      field: "dayPrice",
      headerName: "Prix journée",
      type: "textColumn",
    },
    designation: {
      colId: "designation",
      headerName: "Désignation",
      type: "textColumn",
      valueGetter: ({ data }) => data?.designation || "",
    },
    distanceDeliveryPrice: {
      colId: "distanceDeliveryPrice",
      headerName: "distanceDeliveryPrice",
      type: "textColumn",
      valueGetter: ({ data }) => data?.distanceDeliveryPrice,
    },
    group: {
      colId: "group",
      field: "group",
      headerName: "Groupes",
      type: "textColumn",
    },
    guidanceAntennaModel: {
      colId: "guidanceAntennaModel",
      headerName: "guidanceAntennaModel",
      type: "textColumn",
      valueGetter: ({ data }) => data?.guidanceAntenna?.model || "",
    },
    guidanceAntennaSerial: {
      colId: "guidanceAntennaSerial",
      headerName: "guidanceAntennaSerial",
      type: "textColumn",
      valueGetter: ({ data }) => data?.guidanceAntenna?.serialNumber || "",
    },
    guidanceScreenModel: {
      colId: "guidanceScreenModel",
      headerName: "guidanceScreenModel",
      type: "textColumn",
      valueGetter: ({ data }) => data?.guidanceScreen?.model || "",
    },
    guidanceScreenSerial: {
      colId: "guidanceScreenSerial",
      headerName: "guidanceScreenSerial",
      type: "textColumn",
      valueGetter: ({ data }) => data?.guidanceScreen?.serialNumber || "",
    },
    interactionRenderer: {
      cellRenderer: InteractionRenderer,
      headerName: "Menu",
      colId: "interactionRenderer",
      filter: false,
      floatingFilter: false,
      width: 50,
    },
    image: {
      colId: "image",
      headerName: "Image",
      filter: false,
      floatingFilter: false,
      cellRenderer: MainImage,
      width: 100,
    },
    internId: {
      colId: "internId",
      field: "internId",
      headerName: "N° parc",
      type: "textColumn",
      valueGetter: ({ data }) => data.internId,
    },
    lastCounter: {
      colId: "lastCounter",
      headerName: "Compteur",
      filter: "agNumberColumnFilter",
      valueGetter: ({ data: { lastCounter } }) => {
        return lastCounter ? Number(lastCounter.replace(",", ".")) : "";
      },
    },
    lastDepartureAgency: {
      colId: "lastDepartureAgency",
      field: "lastDepartureAgency",
      headerName: "Agence dernier départ",
      type: "textColumn",
    },
    lastFuelLevel: {
      colId: "lastFuelLevel",
      headerName: "Carburant",
      filter: "agNumberColumnFilter",
      valueGetter: ({ data: { lastFuelLevel } }) => {
        return lastFuelLevel ? Number(lastFuelLevel.replace(",", ".")) : "";
      },
    },
    minIncome: {
      colId: "minIncome",
      field: "minIncome",
      headerName: "Revenu min par contrat",
      type: "textColumn",
      valueGetter: ({ data }) => data.minIncome,
    },
    model: {
      colId: "model",
      field: "model",
      headerName: "Modèle",
      type: "textColumn",
      valueGetter: ({ data }) => data.model,
    },
    nature: {
      colId: "nature",
      headerName: "Nature",
      type: "textColumn",
      valueGetter: ({ data }) => Language.categoryConverter?.[data.category],
    },
    openedCustomer: {
      colId: "openedCustomer",
      headerName: "Client en cours",
      type: "textColumn",
      valueGetter: ({ data }) => data?.openedCustomer?.name || "",
    },
    periodicGeneralInspection: {
      colId: "periodicGeneralInspection",
      comparator: (a, b) => {
        const [aDay, aMonth, aYear] = a?.split("/") || [];
        const [bDay, bMonth, bYear] = b?.split("/") || [];
        const aDate = a ? new Date(aYear, aMonth, aDay) : null;
        const bDate = b ? new Date(bYear, bMonth, bDay) : null;
        return aDate === bDate ? 0 : aDate > bDate ? 1 : -1;
      },
      headerName: "Prochaine VGP",
      filter: "agDateColumnFilter",
      filterParams: {
        buttons: ["clear", "apply"],
      },
      valueGetter: ({ data }) => {
        const [date] = new Date(data?.periodicGeneralInspection?.[0])
          .toLocaleString("fr-FR", {
            timeZone: "UTC",
          })
          .split(" ");
        return data?.periodicGeneralInspection?.[0] ? date : null;
      },
    },
    picture: {
      colId: "picture",
      headerName: "picture",
      type: "textColumn",
      valueGetter: ({ data }) => data?.mainPicture,
    },
    rentalRatioInDays: {
      colId: "rentalRatioInDays",
      cellRenderer: ({ data: { rentalRatioInDays } }) => {
        return rentalRatioInDays
          ? `${Number((rentalRatioInDays * 100).toFixed(2))}%`
          : null;
      },
      headerName: "Tx activité",
      filter: "agNumberColumnFilter",
      valueGetter: ({ data: { rentalRatioInDays } }) => {
        return rentalRatioInDays
          ? Number((rentalRatioInDays * 100).toFixed(2))
          : 0;
      },
    },
    serialNumber: {
      colId: "serialNumber",
      field: "serialNumber",
      headerName: "N° série",
      valueGetter: ({ data }) => data.serialNumber || "",
    },
    state: {
      colId: "state",
      field: "state",
      headerName: "Etat",
      type: "textColumn",
      valueGetter: ({ data }) =>
        Language.machineStateConverter?.[data?.state] || "",
    },
    status: {
      colId: "status",
      field: "status",
      headerName: "Statut",
      valueGetter: ({ data }) => Language.machineStatusConverter[data.status],
    },
    unityPrice: {
      colId: "unityPrice",
      field: "unityPrice",
      headerName: "Prix unitaire",
      type: "textColumn",
    },
    valuePrice: {
      colId: "valuePrice",
      headerName: "valuePrice",
      type: "textColumn",
      valueGetter: ({ data }) => data?.valuePrice,
    },
    year: {
      colId: "year",
      filter: "agNumberColumnFilter",
      headerName: "Année",
      valueGetter: ({ data: { year } }) => {
        const _year = Number(year);
        return isNaN(_year) ? null : _year;
      },
    },
    warrantyExpiresOn: {
      colId: "warrantyExpiresOn",
      comparator: (a, b) => {
        const [aDay, aMonth, aYear] = a?.split("/") || [];
        const [bDay, bMonth, bYear] = b?.split("/") || [];
        const aDate = a ? new Date(aYear, aMonth, aDay) : null;
        const bDate = b ? new Date(bYear, bMonth, bDay) : null;
        return aDate === bDate ? 0 : aDate > bDate ? 1 : -1;
      },
      headerName: "Fin de garantie",
      filter: "agDateColumnFilter",
      filterParams: {
        buttons: ["clear", "apply"],
      },
      valueGetter: ({ data }) => data?.warrantyExpiresOn?.[0],
    },
  };

  const rowClassRules = useMemo(
    () => ({
      isLateDepartureOrReturn: function ({ data }) {
        return ["isLateDeparture", "isLateReturn"].includes(data.status);
      },
      isLocked: function ({ data }) {
        return data.status === "locked";
      },
    }),
    [],
  );

  const { machineGroup } = user || {};
  const { groupList: defaultGroupList = [] } = company.config || {};
  const defaultList = machineGroup?.length ? machineGroup : defaultGroupList;

  const _rowData = selectorList?.length
    ? rowData.filter(
        ({ group, ...rest }) =>
          selectorList.some((g) => group.includes(g)) &&
          (search?.length
            ? JSON.stringify(rest)
                ?.toLowerCase()
                .includes(search?.toLowerCase())
            : true),
      )
    : rowData?.filter((machine) =>
        search?.length
          ? JSON.stringify(machine)
              ?.toLowerCase()
              .includes(search?.toLowerCase())
          : true,
      );

  const internIdList = rowData
    ?.map(({ internId }) => internId)
    ?.filter(
      (internId) => internId && internId !== machineDetails.data?.internId,
    );

  const handleUploadXls = async (e) => {
    setLocalProps({ ...localProps, uploading: true });
    const file = e.target.files[0];
    var extension = file.name.split(".").pop().toLowerCase();
    var allowed = ["xls", "xlsx"];

    if (allowed.includes(extension)) {
      const formData = new FormData();
      formData.append("filedata", file);

      await Machine.importFromXls({ formData, token: user.token });
      constructor();
      fileInput.current.value = null;
    } else {
      setLocalProps({ ...localProps, uploading: false });
      fileInput.current.value = null;
    }
  };

  const _columnDefs = columnDefs?.[view]?.map((el) =>
    view !== "Modèle d'import"
      ? columnsConfiguration?.[el]
      : {
          ...columnsConfiguration?.[el],
          headerName: columnsConfiguration?.[el]?.colId,
        },
  );

  return (
    <div
      className="ag-theme-alpine"
      style={{ height: "100%", margin: "1%", paddingBottom: "5%" }}
    >
      {isOpenAddUpBook && (
        <AddUpdateBooking
          discountGrid={discountGrid}
          handleClose={() => setIsOpenAddUpBook(false)}
          initialBooking={initialBooking}
          role="addBooking"
          setSnackBar={(props) => setSnackBar(props)}
        />
      )}
      {isOpenAddMachine && (
        <AddUpdateMachine
          machineProps={null}
          handleClose={() => setIsOpenAddMachine(false)}
          handleMergeMachine={() => constructor()}
          role="addMachine"
          setSnackBar={(props) => setSnackBar(props)}
          internIdList={internIdList}
        />
      )}
      {isOpenChekingsHistory && (
        <CheckingsHistory
          open={isOpenChekingsHistory}
          handleClose={() => handleCloseChekingsHistoryModal()}
          contractsByMachine={contractsByMachine}
          selectedMachine={selectedMachine}
          user={user}
          members={members}
        />
      )}
      <Box
        key="viewTitle"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "2%",
          marginBottom: "2%",
          borderBottomColor: Colors.greyHighShaded,
          borderBottomWidth: 1,
          borderBottomStyle: "solid",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="view-select-label">Vues</InputLabel>
            <Select
              labelId="view-select-label"
              id="view-select"
              value={view}
              label="Vue"
              onChange={({ target }) => setView(target.value)}
            >
              {defaultViews?.map((view) => (
                <MenuItem key={view} value={view}>
                  {view}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box>
            {isViewAdding ? (
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "1vh",
                }}
              >
                <TextField
                  inputRef={addViewInputRef}
                  size="small"
                  id="add-view"
                  variant="outlined"
                  placeholder="Nom de la vue"
                />
                <Tooltip title={Language.calendar.editGridView}>
                  <SaveIcon
                    style={{
                      color: Colors.green,
                      cursor: "pointer",
                      marginLeft: 5,
                    }}
                    onClick={() => handleAddView()}
                  />
                </Tooltip>
              </Box>
            ) : (
              <Tooltip title={Language.calendar.editGridView}>
                <AddIcon
                  style={{
                    color: Colors.green,
                    cursor: "pointer",
                    marginLeft: 5,
                  }}
                  onClick={() => setIsViewAdding(true)}
                />
              </Tooltip>
            )}
          </Box>
          <Selector
            defaultList={defaultList}
            multiple={true}
            selectorList={selectorList}
            setSelectorList={setSelectorList}
          />
        </Box>
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TextField
            size="small"
            onChange={({ target }) =>
              handleSearch({
                target,
              })
            }
            placeholder="Rechercher"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment>
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            sx={{ minWidth: 150 }}
            value={search}
          ></TextField>
          <Tooltip title={Language.calendar.editGridView}>
            <TableViewIcon
              style={{
                color: Colors.green,
                cursor: "pointer",
                marginLeft: 5,
              }}
              onClick={(e) => setColumnAnchorEl(e.currentTarget)}
            />
          </Tooltip>
          <Menu
            id="edit-grid"
            anchorEl={columnAnchorEl}
            open={Boolean(columnAnchorEl)}
            onClose={() => setColumnAnchorEl(null)}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {Object.entries(columnsConfiguration)
              ?.map(([key, { headerName }]) => ({
                isActive: columnDefs?.[view]?.includes(key),
                key,
                headerName,
              }))
              .sort((a, b) => (a.headerName > b.headerName ? 1 : -1))
              ?.map(({ isActive, key, headerName }) => (
                <MenuItem onClick={() => handleUpdateColumn({ key, isActive })}>
                  <ListItemIcon>
                    {isActive ? (
                      <RemoveIcon style={{ color: Colors.warning }} />
                    ) : (
                      <AddIcon style={{ color: Colors.green }} />
                    )}
                  </ListItemIcon>
                  {headerName}
                </MenuItem>
              ))}
          </Menu>
          {createMachineRestriction ? null : (
            <Tooltip title={Language.catalog.createMachine}>
              <AddIcon
                style={{
                  color: Colors.green,
                  cursor: "pointer",
                  marginLeft: 5,
                }}
                onClick={() => setIsOpenAddMachine(true)}
              />
            </Tooltip>
          )}
          <Tooltip title={Language.catalog.refreshData}>
            <RefreshIcon
              style={{ color: Colors.green, cursor: "pointer", marginLeft: 5 }}
              onClick={() => constructor()}
            />
          </Tooltip>
          <Tooltip title={Language.catalog.downloadData}>
            <DownloadIcon
              style={{ color: Colors.green, cursor: "pointer", marginLeft: 5 }}
              onClick={() => gridApiHandler("exportDataAsExcel")}
            />
          </Tooltip>
          {user.licence === "manager" ? (
            <>
              <Tooltip title={Language.catalog.uploadMachineFile}>
                <UploadFileIcon
                  style={{
                    color: uploading ? Colors.greyShaded : Colors.green,
                    cursor: "pointer",
                    marginLeft: 5,
                  }}
                  onClick={() => fileInput.current.click()}
                />
              </Tooltip>
              <input
                type="file"
                onChange={handleUploadXls}
                accept=".xlsx, .xls"
                ref={fileInput}
                style={{ display: "none" }}
              />
            </>
          ) : null}
        </Box>
      </Box>
      {_rowData?.length && isGridReady && (
        <div className="ag-theme-grid">
          <AgGridReact
            onColumnMoved={() => handleStoreColumnDefs()}
            autoSizeStrategy={{ type: "fitGridWidth" }}
            localeText={AG_GRID_LOCALE_FR}
            rowData={_rowData}
            domLayout="autoHeight"
            ref={gridRef}
            defaultColDef={defaultColDef}
            rowStyle={{
              borderBottomWidth: 1,
              borderColor: Colors.greyShaded,
              textAlign: "center",
              fontSize: "12px",
              cursor: "pointer",
            }}
            onCellClicked={({ colDef, data }) => {
              const { cellRenderer } = colDef || {};
              !cellRenderer && setMachineDetails({ data, isVisible: true });
            }}
            rowHeight={50}
            onFirstDataRendered={onFirstDataRendered}
            columnDefs={_columnDefs}
            paginationPageSize={100}
            pagination={true}
            rowClassRules={rowClassRules}
            getContextMenuItems={getContextMenuItems}
          />
        </div>
      )}
      {machineDetails.data && (
        <MachineDetails
          data={machineDetails.data}
          isVisible={machineDetails.isVisible}
          members={members}
          rebuildMachineList={() => constructor()}
          setMachineDetails={setMachineDetails}
          internIdList={internIdList}
        />
      )}
      <LokaSnackBar />
      <LokaActivityIndicator />
    </div>
  );
};

export default Catalog;
